import React, { ErrorInfo, ReactNode } from "react"
import * as Sentry from "@sentry/gatsby"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"

import Logo from "../Logo"
import Button from "../Forms/Button"

export interface ErrorBoundaryProps {
  children: ReactNode
}

export interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(error: unknown, errorInfo: ErrorInfo) {
    this.setState({ hasError: true })
    Sentry.configureScope(scope => {
      if (errorInfo?.componentStack) {
        scope.setExtra(`componentStack`, errorInfo.componentStack)
      }
    })
    Sentry.captureException(error)
  }

  render() {
    const { children } = this.props
    const { hasError } = this.state

    if (hasError) {
      return (
        <div className="container pt-12 text-center xl:w-4/12 md:w-8/12 w-11/12">
          <Helmet>
            <title>Something Went Wrong - Wolf & Badger</title>
          </Helmet>
          <div className="mb-12">
            <Link to="/" aria-label="Home">
              <Logo />
            </Link>
          </div>
          <h2>Something went wrong</h2>
          <p className="mb-4">
            Try reloading the page, or contact us if the problem persists.
          </p>
          <p className="flex justify-center">
            <Button onClick={() => window.location.reload()}>Reload</Button>
          </p>
        </div>
      )
    }
    return children
  }
}

export default ErrorBoundary
